import React, { FunctionComponent } from 'react';
import type { CompanyPerson, DataCategory } from '../../../types/recruitmentShow';

type Props = {
  companyPeople: CompanyPerson[];
  noIconImg: string;
  isStopped: boolean;
  dataCategory: DataCategory;
  dataValue: string;
  isPreview: boolean;
};

export const Presentation: FunctionComponent<Props> = ({
  companyPeople,
  noIconImg,
  isStopped,
  dataCategory,
  dataValue,
  isPreview
}) => {
  if (companyPeople.length === 0) return null

  return (
    <section className="recruitment__show__content recruitment__show__people" id='company-people-section'>
      <div className="recruitment__show__company__section people">
        <h2 className="title">メンバー</h2>
        <div className="recruitment__show__company__slider js-recruitment-people gtm-company_people-view-count" data-event-name='company_people on screen' data-category={isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent} data-value={dataValue}>
          {companyPeople.map((person) => (
            <a
              key={person.id}
              href={`/company_people/${person.id}`}
              target="_blank"
              className="recruitment__show__company__slider--item"
              {...(!isPreview && {
                'data-event': 'click',
                'data-category': isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent,
                'data-value': dataValue
              })}
            >
              <img
                src={person.image.url ?? noIconImg}
                alt={`${person.id}の画像`}
              />
              <p>{person.name}</p>
              <p className="role">{person.position}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
